import { put } from 'redux-saga/effects';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* getCompanyList(action) {
    try {
        const response = yield endpoint.get('addresses?type=2');
        
        response.data.forEach(function(company){
            company.key = company.id
        })
        /*
        const nrCompanies = 100;
        let response = {
            data: []   
        };

        for(var i = 0; i < nrCompanies; i++){
            response.data.push({
                key: i,
                name: 'Företag' + i
            });
        }
        */
        yield put({ type: types.SAGA_COMPANY_GET.SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.SAGA_COMPANY_GET.FAILURE, error });
    }
}


// WEBPACK FOOTER //
// ./src/sagas/company.js